import { MainPageBlockClientData, WIDGET_TYPE } from '@yandex-int/k-common/typings/api/models/main-page';
import React from 'react';

import type { ShowcaseMetrikaParams } from 'common.components/typings';
import { ActualContentWidgetView } from 'common.components/widgets.actual-content/__view/actual-content__view';
import { BannerSpinnerWidget } from 'common.components/widgets.banner-spinner/banner-spinner';
import { ThemeProvider } from '@edu-frontend/modules/src/shared/lib/ThemeProvider';
import { LessonsCarouselsWidget } from 'common.components/widgets.lessons-carousels/lessons-carousels';
import { MarkdownWidget } from 'common.components/widgets.markdown/markdown';
import { SubjectsWidgetView } from 'common.components/widgets.subjects/subjects';
import { TeacherReserve } from 'common.components/widgets.teacher-reserve/teacher-reserve';
import { TeacherStories } from 'common.components/teacher-stories/teacher-stories';
import { CourseContainerWidgetV2 } from 'common.components/widgets.course-container-v2/course-container-widget-v2';
import { hrLight } from '@edu-frontend/modules/src/components/ui/Theme';
import { CourseCalendarWidget } from 'common.components/widgets.course-calendar/course-calendar-widget';
import { CourseContainerLastLessonWidget } from 'common.components/widgets.course-container-last-lesson/course-container-last-lesson-widget';
import { CourseContainerWidgetPublicV2 } from 'common.components/widgets.course-container-v2/course-container-widget-public-v2';
import { PublicLessonsWidget } from 'common.components/widgets.public-lessons/public-lessons';

interface Props {
    widget: MainPageBlockClientData;
    metrikaParams?: ShowcaseMetrikaParams;
    isPublic?: boolean;
}

// eslint-disable-next-line complexity
export const WidgetView = ({ widget, metrikaParams, isPublic }: Props) => {
    switch (widget.type) {
        case WIDGET_TYPE.TEACHER_RESERVE: {
            return <TeacherReserve />;
        }
        case WIDGET_TYPE.STORIES: {
            return <TeacherStories />;
        }
        case WIDGET_TYPE.LESSONS_CAROUSELS: {
            return (
                <LessonsCarouselsWidget carousels={widget.additional_info.carousels} metrikaParams={metrikaParams} />
            );
        }
        case WIDGET_TYPE.BANNER_CAROUSEL: {
            return <BannerSpinnerWidget banners={widget.additional_info.banners} metrikaParams={metrikaParams} />;
        }
        case WIDGET_TYPE.ACTUAL_CONTENT: {
            return <ActualContentWidgetView data={widget} hideSelector={isPublic} metrikaParams={metrikaParams} />;
        }
        case WIDGET_TYPE.MARKDOWN: {
            return <MarkdownWidget data={widget} />;
        }
        case WIDGET_TYPE.SUBJECTS: {
            return <SubjectsWidgetView data={widget} metrikaParams={metrikaParams} />;
        }
        case WIDGET_TYPE.COURSE_CONTAINER_CONTENT: {
            return (
                <ThemeProvider isRoot={false} theme={hrLight}>
                    {isPublic ? <CourseContainerWidgetPublicV2 /> : <CourseContainerWidgetV2 />}
                </ThemeProvider>
            );
        }
        case WIDGET_TYPE.COURSE_CONTAINER_NEXT_LESSONS: {
            return <CourseContainerLastLessonWidget />;
        }
        case WIDGET_TYPE.COURSE_CALENDAR: {
            return <CourseCalendarWidget />;
        }
        case WIDGET_TYPE.PUBLIC_LESSONS_SHOWCASE: {
            return <PublicLessonsWidget data={widget} />;
        }

        default:
            return null;
    }
};
